// removed by extract-text-webpack-plugin
module.exports = {"header":"i3TqC _37W4X _2AJrG _1PyuO _37W4X _2AJrG","editor":"_2XxIP _2kZNz","list":"_3JeVK hPXk7","label":"_2Jnvg _38618 _3Dqep _2Hk-A _1s_jv _3FzDO","labelEditing":"CMeaj _38618 _3Dqep _2Hk-A _1s_jv","name":"_1Jfun _2kZNz _3or2i","edit":"y4x81 _342no","delete":"SKUG5 _1a-AI"};


//////////////////
// WEBPACK FOOTER
// ./questions/containers/EditLabels.css
// module id = 1661
// module chunks = 3